import React, { type FC } from 'react'

import Text, { TextRoles } from 'components/Text'
import Image from 'components/Image'
import Messages from 'messages.app'

import styles from './styles.scss'

const Desktop: FC = () => {
  return (
    <div className={styles['desktop-view']}>
      <Image
        imageUrl='https://rukminim1.flixcart.com/www/{@width}/{@height}/promos/30/05/2023/cae00fad-5cc5-44c9-9b68-5215f383532b.png?q={@quality}'
        alternateText='Error Image'
        height={200}
        width={200}
        className={styles['image']}
      ></Image>
      <div>
        <Text role={TextRoles.HeadingLite}>{Messages.DESKTOP_SUPPORT}</Text>
      </div>
    </div>
  )
}

export default Desktop
